import { Urls } from '@core/config';

export class AuthenticationUrls {
	public static get Activate(): string {
		return `${Urls.BASE_URL}/sec/public/security/users/activate`;
	}

	public static get FirstPassword(): string {
		return `${Urls.BASE_URL}/sec/public/security/users/first-password`;
	}

	public static get Reset(): string {
		return `${Urls.BASE_URL}/sec/public/security/users/reset`;
	}

	public static get ResetPassword(): string {
		return `${Urls.BASE_URL}/sec/public/security/users/reset-password`;
	}

	public static get ExpiredPassword(): string {
		return `${Urls.BASE_URL}/sec/public/security/users/expired-password`;
	}
}
